export enum AppEnv {
  DEVELOPMENT = 'DEVELOPMENT',
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION',
}

export enum Language {
  en = 'en',
  pt = 'pt',
  es = 'es',
  uk = 'uk',
}

export const DEFAULT_LANGUAGE = Language.en;

export const DEFAULT_TIMEZONE = 'local';
